/* CS — Etiquetas de tarjeta bajo la imagen.
 * Maximize pinta las etiquetas (p. ej. «Más vendido», «Agotado») dentro de la imagen de la
 * tarjeta, en .label-container. Este script las lleva a una fila .cs-card-labels del área de
 * información, junto al badge de Entrega Express y antes del botón. No crea etiquetas ni
 * cambia su contenido: solo mueve los contenedores que pinta $store.xLabelsAndBadges.
 */
(function (root) {
  'use strict';

  if (!root || !root.document || root.CentralSportCardLabels) return;

  var doc = root.document;
  var CARD_SELECTOR = '.product-card__wrapper';
  var IMAGE_SELECTOR = '.product-card__image-wrapper';
  var SOURCE_SELECTOR = IMAGE_SELECTOR + ' .label-container';
  var ROW_CLASS = 'cs-card-labels';
  var EXPRESS_SELECTOR = '.cs-express-delivery-badge';
  var BUTTON_SELECTOR = '.product-card__widget-list-layout';

  function ownRow(card) {
    var rows = card.getElementsByClassName(ROW_CLASS);
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].closest(CARD_SELECTOR) === card) return rows[i];
    }
    return null;
  }

  function ensureRow(card) {
    var row = ownRow(card);
    if (row) return row;

    var express = card.querySelector(EXPRESS_SELECTOR);
    if (express && express.closest(CARD_SELECTOR) !== card) express = null;
    var anchor = express || card.querySelector(BUTTON_SELECTOR);
    if (!anchor || !anchor.parentNode) return null;

    row = doc.createElement('div');
    row.className = ROW_CLASS;
    anchor.parentNode.insertBefore(row, anchor);
    if (express) row.appendChild(express);
    return row;
  }

  function processCard(card) {
    if (!card) return;
    var image = card.querySelector(IMAGE_SELECTOR);
    if (!image || image.closest(CARD_SELECTOR) !== card) return;

    var sources = image.querySelectorAll('.label-container');
    var filled = [];
    for (var i = 0; i < sources.length; i++) {
      if (sources[i].querySelector('.x-badge-container')) filled.push(sources[i]);
    }
    if (!filled.length) return;

    var row = ensureRow(card);
    if (!row) return;

    var previous = row.querySelectorAll(':scope > .label-container');
    for (var j = 0; j < previous.length; j++) previous[j].remove();

    var first = row.firstChild;
    for (var k = 0; k < filled.length; k++) row.insertBefore(filled[k], first);
  }

  function scan(scope) {
    var sources = (scope || doc).querySelectorAll(SOURCE_SELECTOR);
    for (var i = 0; i < sources.length; i++) processCard(sources[i].closest(CARD_SELECTOR));
  }

  function onMutations(mutations) {
    var cards = [];
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      if (!target || target.nodeType !== 1 || !target.closest(IMAGE_SELECTOR)) continue;
      var card = target.closest(CARD_SELECTOR);
      if (card && cards.indexOf(card) === -1) cards.push(card);
    }
    for (var j = 0; j < cards.length; j++) processCard(cards[j]);
  }

  function start() {
    scan(doc);
    if (typeof root.MutationObserver === 'function') {
      new root.MutationObserver(onMutations).observe(doc.body, { childList: true, subtree: true });
    }
  }

  root.CentralSportCardLabels = { namespace: 'cs-card-labels', scan: scan };

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})(typeof window !== 'undefined' ? window : null);
